import { ContactFormContent } from "src/modules/pe-landing-module/data/interfaces"
import { IPrimitiveProps } from "../../section/Primitive"

/* Protopia Ecosystem component */
export interface ICFTitleProps extends IPrimitiveProps {
   
}
const CFTitle = (props: ICFTitleProps): JSX.Element => {
    const primitive: ContactFormContent = ( props.primitive || {} ) as ContactFormContent
    return !! primitive.title 
        ?
        <div 
            className='pe-cf-title-container h pt-3'
        >
            { primitive.title }
        </div>
        :
        <></>
}
export default CFTitle